module.exports = __webpack_public_path__ + "img/Trupp_für_soziale_Betreuung.5faf455b.svg";